import { useEffect } from 'react';

import { useChannel } from './Channel';

type Props = {
  event: string,
  handler: Function,
};

export const SocketEvent = ({ event, handler }: Props) => {
  const channel = useChannel();

  useEffect(() => {
    if (!handler) {
      throw new Error('error');
    }
    if (channel) {
      channel.bind(event, handler);
    }
    return () => {
      if (channel) {
        channel.unbind(event, handler);
      }
    };
  }, [channel, event]);

  return null;
};
